import React from 'react';
import { createRoot } from 'react-dom/client';
import { LegalInformation } from '../main-app/components/LegalInformation/LegalInformation';

// Self-mounting entry pack: create a single React root on #legal-information at
// DOMContentLoaded and render the legal information once. Previously this was a
// function component that called createRoot(node) during render, which Suspense
// re-invoked on the same node and produced React's duplicate-createRoot warning.
document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('legal-information');

  if (!node) return;

  const siretNumber = node.getAttribute('data-siret-number') || '';
  const establishmentNumber = node.getAttribute('data-establishment-number') || '';
  const ndaNumber = node.getAttribute('data-nda-number') || '';

  const root = createRoot(node);
  root.render(
    <LegalInformation
      siretNumber={siretNumber}
      establishmentNumber={establishmentNumber}
      ndaNumber={ndaNumber}
    />,
  );
});
